const BundleCardType = (type, displayType, coverType, cardTest) => {
  let cardType = cardTest ? 'PickAndMixCard' : 'bundle-game-card';
  if (type !== 'game' && type !== 'dlc' && type !== 'bundle') {
    cardType = cardTest ? 'PickAndMixCard PickAndMixCard--bundleProduct' : 'bundle-product-card';
  }
  if (displayType !== 'game' && displayType !== 'dlc') {
    cardType = cardTest ? 'PickAndMixCard PickAndMixCard--bundleProduct' : 'bundle-product-card';
  }
  if (type === 'audio' || displayType === 'audio') {
    cardType = cardTest ? 'PickAndMixCard PickAndMixCard--bundleProduct' : 'bundle-product-card  bundle-audio-card';
  }
  if (coverType === '16x9') {
    cardType = cardTest ? 'PickAndMixCard' : 'bundle-game-card';
  }
  if (coverType === 'portrait') {
    cardType = cardTest ? 'PickAndMixCard PickAndMixCard--bundleProduct' : 'bundle-product-card';
  }
  if (coverType === 'square') {
    cardType = cardTest ? 'PickAndMixCard PickAndMixCard--bundleProduct' : 'bundle-product-card';
  }
  if (coverType === 'landscape') {
    cardType = cardTest ? 'PickAndMixCard PickAndMixCard--bundleProduct' : 'bundle-product-card';
  }

  return (cardType);
};

export default BundleCardType;
